import React from "react";
import {
  FieldLabel,
  InfoCallout,
  OnboardingInput,
  OnboardingSelect,
  PrimaryButton,
} from "./OnboardingFields";

function IdentityStep({ form, onChange, onContinue }) {
  const canContinue =
    form.title && form.birthName.trim() && form.firstName.trim();

  return (
    <div className="flex flex-col min-h-[calc(100vh-8rem)] sm:min-h-0">
      <h2 className="font-logo text-3xl sm:text-4xl text-black mb-6 sm:mb-8 leading-tight">
        Configurons ton espace personnel.
      </h2>

      <InfoCallout>
        Ces informations servent à t&apos;identifier dans les registres des
        administrations publiques. Il est important de les saisir exactement comme
        elles figurent sur tes documents d&apos;identité (carte d&apos;identité,
        passeport, etc.).
      </InfoCallout>

      <div className="space-y-5 flex-1">
        <div>
          <FieldLabel htmlFor="title" required>
            Civilité
          </FieldLabel>
          <OnboardingSelect
            id="title"
            value={form.title}
            onChange={(e) => onChange("title", e.target.value)}
            placeholder="Civilité"
          >
            <option value="M">Monsieur</option>
            <option value="F">Madame</option>
          </OnboardingSelect>
        </div>

        <div>
          <FieldLabel htmlFor="birthName" required>
            Nom de naissance
          </FieldLabel>
          <OnboardingInput
            id="birthName"
            placeholder="Nom de naissance"
            value={form.birthName}
            onChange={(e) => onChange("birthName", e.target.value)}
            required
          />
        </div>

        <div>
          <FieldLabel htmlFor="firstName" required>
            Prénom(s)
          </FieldLabel>
          <OnboardingInput
            id="firstName"
            placeholder="Prénom(s)"
            value={form.firstName}
            onChange={(e) => onChange("firstName", e.target.value)}
            required
          />
        </div>
      </div>

      <div className="mt-8 sm:mt-10 flex justify-end pb-4">
        <PrimaryButton
          variant="green"
          onClick={onContinue}
          disabled={!canContinue}
          className="w-full sm:w-auto"
        >
          Continuer
        </PrimaryButton>
      </div>
    </div>
  );
}

export default IdentityStep;
